import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparkles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.3831 6.83118L11.4013 4.69612L9.26624 3.71429L11.4013 2.74027L12.3831 0.597412L13.3572 2.74027L15.5 3.71429L13.3572 4.69612L12.3831 6.83118Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.68164 7.22119L12.9678 9.16846L8.68164 11.1167L6.7334 15.4028L4.78613 11.1167L0.5 9.16846L4.78613 7.22119L6.7334 2.93506L8.68164 7.22119ZM5.54102 7.97607L2.91699 9.16846L5.54102 10.3618L6.7334 12.9849L7.92676 10.3618L10.5498 9.16846L7.92676 7.97607L6.7334 5.35205L5.54102 7.97607Z",
		fill: "currentColor"
	})]
});
export default SvgSparkles;
